import PropTypes from 'prop-types';
import cc from 'classcat';

import { customThemes } from '../../lib/themes';
import { fromCents, plainNumber } from '../../lib/formatters/numbers';

import Stat from './Stat';
import styles from './styles.module.scss';

export const THEMES = customThemes([
  'dark',
  'light',
  'kickstarter',
  'transformer',
]);

const GameStats = ({
  theme,
  bet,
  betPerRound,
  pot,
  pledged,
  players,
  className,
  customStyles = {},
}) => {
  bet = normalizeNumber(bet);
  pot = normalizeNumber(pot);
  pledged = normalizeNumber(pledged);
  players = normalizeNumber(players);

  const showBet = bet !== false;
  const showPledged = pledged !== false;
  const showPot = !showPledged && bet > 0 && pot !== false;

  return (
    <div className={cc([styles.container, className])}>
      {showBet && (
        <Stat
          theme={theme}
          value={fromCents(bet)}
          label="bet"
          subLabel={betPerRound ? `per ${betPerRound}` : ''}
          customStyles={customStyles}
        />
      )}
      {players !== false && (
        <Stat
          theme={theme}
          value={plainNumber(players)}
          label="players"
          customStyles={customStyles}
        />
      )}
      {showPot && (
        <Stat
          theme={theme}
          value={fromCents(pot, { round: true })}
          label="pot size"
          customStyles={customStyles}
        />
      )}
      {showPledged && (
        <Stat
          theme={theme}
          value={fromCents(pledged, { round: true })}
          label="pledged"
          customStyles={customStyles}
        />
      )}
    </div>
  );
};

const normalizeNumber = (number) => {
  if (number === false) return number;
  const normalNumber = parseFloat(number);
  if (isNaN(normalNumber)) return false;
  return normalNumber;
};

GameStats.propTypes = {
  theme: PropTypes.oneOf(THEMES),
  bet: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  betPerRound: PropTypes.oneOf(['', 'month']),
  pot: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  pledged: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  players: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  className: PropTypes.string,
  customStyles: PropTypes.shape({
    stat: PropTypes.string,
    value: PropTypes.string,
  }),
};

GameStats.defaultProps = {
  theme: 'dark',
  bet: false,
  betPerRound: '',
  pot: false,
  pledged: false,
  players: false,
};

export default GameStats;
